import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-users-01',
  imports: [],
  templateUrl: './users-01.html',
  styleUrl: './users-01.scss',
})
export class Users01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
